import { UserActivityCategory, UserActivityTypes } from '@pascal/iframe-service';
import React, { useCallback } from 'react';

import { GameRedirectionSource, PopUpActionType } from '../../../../../enums';
import { integration } from '../../../../../services';
import { env } from '../../../../../environment';
import { useStore } from '../../../../../hooks';
import { Popup } from '../../../../../models';

interface SidebarMenuHeaderProps {
  title: string;
  bannerPopup?: Popup;
  onClose: () => void;
}

export const SidebarMenuHeader: React.FC<SidebarMenuHeaderProps> = ({ title, onClose, bannerPopup }) => {

  const { userActivityStore } = useStore();

  const bannerPath = bannerPopup?.bannerUrl;

  const handleBannerClick = useCallback(() => {
    if (!bannerPopup) return;
    const { actionType, redirectionGameId: gameId, id } = bannerPopup;
    if (actionType === PopUpActionType.GameRedirection && gameId) {
      integration.current.changeGame({ gameId, source: GameRedirectionSource.Banner });
      userActivityStore.sendTrackUserActivity({
        category: UserActivityCategory.PromoTools,
        type: UserActivityTypes.SidebarMenuBanner,
        data: id
      });
      onClose();
    }
  }, [bannerPopup, userActivityStore, onClose]);

  return (
    <div className="side-menu-new-top-wrapper">
      <div className="side-menu-new-top">
        <div className="side-menu-new-action" onClick={onClose}>
          <i className="icon-new-lobby" />
        </div>
          <p className="side-menu-new-action-text">{title}</p>
        <button type={"button"} className="side-menu-close-button" onClick={onClose}>
          <i className="icon-close side-menu-close-icon" />
        </button>
      </div>
      {
        bannerPath ? (
          <div className="atlantis-block" onClick={handleBannerClick}>
            <img
              alt="banner"
              className="atlantis-img"
              src={`${env.filesUrl}/${bannerPath}`}
            />
          </div>
        ) : null
      }
    </div>
  );
};
